import { createSelector } from 'reselect';

const list = state => state.taskGroups.list;
const selectedGuid = state => state.taskGroups.selectedGuid;

const selectedTaskGroup = createSelector(
  [list, selectedGuid],
  (taskGroups, taskGroupGuid) => {
    const selected = !taskGroups ? null : taskGroups.find(taskGroup => taskGroup.taskGroupGuid === taskGroupGuid);
    return !selected ? null : selected;
  },
);

export default { selectedTaskGroup };
